<template>
    <div class="flex flex-col md:flex-row gap-4">
        <div
            class="flex-1 border-solid rounded-xl border-t-20 border-maroon bg-grey p-6 flex flex-col items-center gap-3"
        >
            <h5 class="text-2xl text-center">Clinical and Radiographic Features<sup>1</sup></h5>

            <div class="flex flex-col self-start gap-4">
                <div class="flex items-start gap-6">
                    <img
                        src="@/assets/img/kidney.svg"
                        alt="Kidney lightning icon"
                        class="size-14"
                    />

                    <ul class="list-disc font-light">
                        <li>
                            Recurrent nephrolithiasis: kidney ultrasound often reveals multiple bilateral radiopaque
                            calculi
                        </li>
                    </ul>
                </div>

                <div class="flex items-start gap-6">
                    <img src="@/assets/img/graphics/eskd/kidneys-maroon.svg" alt="Acute rejection" class="size-14" />

                    <ul class="list-disc font-light">
                        <li>
                            Nephrocalcinosis: calcium deposits tend to be densest in the corticomedullary regions in
                            older children or adults but diffuse with few, if any, observable discrete stones <br />in infants
                        </li>
                    </ul>
                </div>

                <div class="flex items-start gap-6">
                    <img src="@/assets/img/graphics/eskd/kidney-maroon.svg" alt="Kidney icon" class="size-14" />

                    <ul class="list-disc font-light">
                        <li>A child with a first kidney stone</li>
                        <li>A child younger than 12 months with failure to thrive and impaired kidney function</li>
                        <li>
                            Reduced kidney function or kidney failure at any age with a history of kidney stones or
                            nephrocalcinosis
                        </li>
                    </ul>
                </div>

                <div class="flex items-start gap-6">
                    <img src="@/assets/img/kidney-stones-filled-pink.svg" alt="Kidney stones" class="size-14" />

                    <ul class="list-disc font-light">
                        <li>Stone composition of pure CaOx monohydrate</li>
                        <li>Oxalate crystals identified in any biological fluid or tissue (e.g. kidney biopsy)</li>
                    </ul>
                </div>
            </div>
        </div>

        <div
            class="flex-1 border-solid rounded-xl border-t-20 border-purple bg-grey p-6 flex flex-col items-center gap-3"
        >
            <h5 class="text-2xl text-center">Laboratory Findings</h5>

            <div class="flex flex-col self-start gap-4">
                <div class="flex items-start gap-6">
                    <img src="@/assets/img/graphics/eskd/bladder-purple.svg" alt="Bladder icon" class="size-14" />

                    <ul class="list-disc font-light">
                        <li>
                            Elevated UOx excretion (&gt;0.5 mmol/1.73 m<sup>2</sup>/24 hours)<sup>2</sup>
                        </li>
                        <li>
                            Elevated urinary glycolic acid (glycolate) concentration; occurs in ~75% of individuals with
                            PH1<sup>1</sup>
                        </li>
                    </ul>
                </div>

                <div class="flex items-start gap-6">
                    <img src="@/assets/img/graphics/eskd/beaker-purple.svg" alt="Beaker icon" class="size-14" />

                    <ul class="list-disc font-light">
                        <li>
                            Elevated POx concentration: individuals with PH1 and well-preserved eGFR typically have
                            mildly elevated values<sup>1</sup>
                        </li>
                        <li>
                            POx concentrations are typically substantially elevated in individuals with eGFR &lt;30
                            mL/min/1.73 m<sup>2</sup> <br />(CKD stages 4 and 5)<sup>1</sup>
                        </li>
                        <li>POx concentrations &gt;20 µmol/L are suggestive of PH1<sup>2</sup></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
